import { useTheme } from "next-themes";
import React, { createContext, useContext, useEffect, useState } from "react";
import { getCookie } from "../Misc";

const AppearanceContext = createContext();

export const AppearanceProvider = ({ children }) => {
  const [appearance, setAppearance] = useState(
    localStorage.getItem("color-theme")
      ? localStorage.getItem("color-theme")
      : getCookie("color-theme")
      ? getCookie("color-theme")
      : "blue"
  );
  const { theme: ogTheme, systemTheme } = useTheme();

  useEffect(() => {
    const root = document.documentElement;

    const themes = {
      blue: {
        "--web-primary": "#0078C8",
        "--web-secondary": "#012F4E",
        "--dark-secondary": "#345b83",
      },
      indigoBlue: {
        "--web-primary": "#191970",
        "--web-secondary": "#7070bf",
        "--dark-secondary": "#42427c",
        "--dark-primary": "#4c4ce9",
      },
      // green: {
      //   "--web-primary": "#58855C",
      //   "--web-secondary": "#0E402F",
      //   "--dark-secondary": "#6b7e6d",
      // },
      purple: {
        "--web-primary": "#8f59a6",
        "--web-secondary": "#493352",
        "--dark-secondary": "#62237e",
      },
      grey: {
        "--web-primary": "#547792",
        "--web-secondary": "#2d4151",
        "--dark-secondary": "#687a88",
      },
      // red: {
      //   "--web-primary": "#CD5656",
      //   "--web-secondary": "#5c2222",
      //   "--dark-secondary": "#5c2222",
      // },
      //TrustBlue

      trustBlue: {
        "--web-primary": "#084B83",
        "--web-secondary": "#062F4F",
        "--dark-secondary": "#0479d8",
      },

      //Soft Blue

      softBlue: {
        "--web-primary": "#4BA3C7", // Muted Soft Blue
        "--web-secondary": "#0075aa", // Slightly darker for contrast
        "--dark-secondary": "#2E6D8E", // Darker variant for hover/dark mode
      },
    };

    const theme = themes[appearance];
    if (theme) {
      root.style.setProperty("--web-primary", theme["--web-primary"]);
      if (
        ogTheme === "dark" ||
        (ogTheme === "system" && systemTheme === "dark")
      ) {
        root.style.setProperty("--web-secondary", theme["--dark-secondary"]);
        if (theme["--dark-primary"]) {
          root.style.setProperty("--web-primary", theme["--dark-primary"]);
        }
      } else {
        root.style.setProperty("--web-secondary", theme["--web-secondary"]);
      }
    }

    document.cookie = `color-theme=${appearance}; path=/`;
    localStorage.setItem("color-theme", appearance);
  }, [appearance, ogTheme, systemTheme]);

  return (
    <AppearanceContext.Provider value={{ appearance, setAppearance }}>
      {children}
    </AppearanceContext.Provider>
  );
};

export const useAppearance = () => useContext(AppearanceContext);
